import type { IAccessDoorRepository, AccessDoorListParams } from '@yawi/domain';
import type {
  AccessDoor,
  AutoMapCamerasResponse,
  UpdateDoorCameraRequest,
  UpdateDoorSectionRequest,
} from '@yawi/types';
import type { PaginatedResponse } from '@yawi/domain';
import { getApiClient, tenantHeaders } from '../../http/apiClient';

export class ApiAccessDoorRepository implements IAccessDoorRepository {
  async listDoors(params: AccessDoorListParams = {}): Promise<PaginatedResponse<AccessDoor>> {
    const { page = 1, limit = 20, search, sectionId, tenantId } = params;
    const query: Record<string, string | number> = { page, limit };
    if (search) query.search = search;
    if (sectionId) query.sectionId = sectionId;
    return getApiClient().get<PaginatedResponse<AccessDoor>>('v1/access-doors', {
      params: query,
      ...tenantHeaders(tenantId),
    });
  }

  async updateDoorCamera(doorId: string, dto: UpdateDoorCameraRequest, tenantId?: string): Promise<AccessDoor> {
    return getApiClient().patch<AccessDoor>(`v1/access-doors/${doorId}/camera`, dto, tenantHeaders(tenantId));
  }

  async updateDoorSection(doorId: string, dto: UpdateDoorSectionRequest, tenantId?: string): Promise<AccessDoor> {
    return getApiClient().patch<AccessDoor>(`v1/access-doors/${doorId}/section`, dto, tenantHeaders(tenantId));
  }

  async autoMapCameras(tenantId?: string): Promise<AutoMapCamerasResponse> {
    return getApiClient().post<AutoMapCamerasResponse>('v1/access-doors/auto-map-cameras', {}, tenantHeaders(tenantId));
  }
}
